import ConnectServer from 'utils/connect_server'
import * as types from 'redux/types'
import { message } from 'antd';


export const onChangePublic = (prop, value): any => (dispatch) => {
 
  dispatch({ type: types.CHANGE_PUBLIC, payload: { prop, value } });
}
 export const checkCompleteInfo = (ctx): any => (dispatch) => {
  if(!ctx.user?.first_name||!ctx.user?.last_name){
    onChangePublic('completeInfoModal',true)(dispatch)
    return true  
  }else{
    checkCompleteRiskInfo(ctx)(dispatch)
  }

}
export const checkCompleteRiskInfo = (ctx): any => (dispatch) => {
if(!ctx?.user?.risk_range||!ctx?.user?.net_range){
  onChangePublic('checkRiskModal',true)(dispatch)
  return true  
}
}


